export default "__VITE_ASSET__CUEh7_Ce__"